import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import { dynamicDataAttribute, toOneString } from 'helpers/utils'

const Legend = ({ children, className, label, ...props }) => (
  <Wrapper className={ className } label={ label } data-non-empty { ...dynamicDataAttribute('legend', toOneString(label)) } { ...props }>
    { children }
  </Wrapper>
)

Legend.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string,
  label: PropTypes.string
}

export default Legend


const Wrapper = styled.div`
  display: table;
  color: ${Theme.colors.black};
  ${Media.desktop`
    padding-left: 168px;
  `}

  & + & {
    margin-top: 21px;
  }

  &::before {
    content: attr(label);
    display: block;
    font-weight: 600;
    ${Media.desktop`
      float: left;
      margin-left: -168px;
    `}
    ${Media.mobile`
      padding-bottom: 5px;
    `}
  }
`
